import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { Device } from "utils/device";

const SupportTitle: FunctionComponent = () => {
  return (
    <S.Title>
      <S.TermsWordWrap>FAQs</S.TermsWordWrap>
      <br />
      <S.PoliciesWordWrap>& support</S.PoliciesWordWrap>
      <br />
    </S.Title>
  );
};

const S = () => {};

S.Title = styled.h1`
  line-height: 2.5rem;

  @media (min-width: ${Device.mobile}) {
    line-height: 3rem;
  }
`;

S.TermsWordWrap = styled.span`
  font-weight: 800;
  font-size: 3.625rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 5.06rem;
  }
`;

S.PoliciesWordWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
  font-size: 3.625rem;

  @media (min-width: ${Device.mobile}) {
    font-size: 5.06rem;
  }
`;

export default SupportTitle;
